import { frontendURL } from '../../../../helper/URLHelper';

const campaigns_flow = accountId => ({
  parentNav: 'campaigns_flow',
  routes: [
    'campaigns_flow',
  ],
  menuItems: [
    {
      icon: 'contact-card-group',
      label: 'CAMPAIGNS_FLOW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns_flow`),
      toStateName: 'campaigns_flow',
    }
  ],
});

export default campaigns_flow;
